import React from "react";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import { useTranslation } from "react-i18next";

import numberColumn from "components/tables/columns/NumberColumn";
import textColumn from "components/tables/columns/TextColumn";
import { getUsageCategoryList, TokenUsage, UsageCategoryKey, UsageMetric, UserUsage } from "routes/apiUsage/types/Usage";
import { Paper } from "@mui/material";
import StripedDataGrid from "components/uiElements/dataGrid/StripedDataGrid";

const UsageCategoryList = getUsageCategoryList();

interface UsersUsageDataGrid {
  onClick?: (userId: string) => void;
  usageMetric: UsageMetric;
  userUsage: Array<UserUsage>;
}

export default function UsersUsageDataGrid(props: UsersUsageDataGrid): React.JSX.Element {
  const { i18n } = useTranslation();

  function AccountValueGetter(value: any, row: UserUsage, params: GridColDef): number {
    const totalValue = (row.tokens || []).reduce((result, token: TokenUsage) => {
      const value = token[props.usageMetric][params.field as UsageCategoryKey] || 0;
      return result + value;
    }, 0);
    
    return totalValue;
  }

  const columns = [{
    field: "name",
    flex: 1,
    headerName: i18n.t("name"),
    ...textColumn()
  }, {
    field: "email",
    flex: 1,
    headerName: i18n.t("email"),
    ...textColumn()
  }]
  
  for (const category of UsageCategoryList) {
    columns.push({
      field: category,
      flex: 1,
      headerName: i18n.t(`usage.categories.${category}`),
      valueGetter: AccountValueGetter,
      ...numberColumn()
    });
  }

  return (
    <Paper>
      <StripedDataGrid
        columns={columns}
        initialState={{
          pagination: {
            paginationModel: {
              pageSize: 10
            }
          }
        }}
        onRowClick={(params, event, details) => {
          if (props.onClick) {
            props.onClick(params.row.id);
          }
        }}
        pageSizeOptions={[10, 25, 50]}
        rows={props.userUsage}
        rowSelection={false}
        sortingOrder={["desc", "asc", null]}
        sx={{
          '& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within': {
            outline: 'none',
          },
          '& .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-columnHeader:focus-within': {
            outline: 'none',
          },
          cursor: props.onClick ? "pointer" : ""
        }}
      />
    </Paper>
  )
}